// // apps/web/src/api.ts
// export const API = process.env.REACT_APP_API_URL!;

// export async function login(email: string, password: string) {
//   const res = await fetch(`${API}/auth/login/`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ email, password }),
//     credentials: 'include',          // only if you rely on a session cookie
//   });
//   return res.json();
// }


// Normalise and expose the API base + handy endpoints

// Prefer env var (works in prod builds). If missing (local dev),
// fall back to same-origin + '/api', or localhost:8000 if you're
// opening a static file / different host.
// const fromEnv = (process.env.REACT_APP_API_URL || '').replace(/\/+$/,''); // e.g. https://api.example.com/api

// const guessSameOrigin = `${window.location.protocol}//${window.location.host}`; // e.g. http://localhost:3000
// const fallbackBase =
//   // if you serve web and api from the same origin with a dev proxy:
//   `${guessSameOrigin}/api`;

// // Final API base (should point to ".../api")
// export const API = fromEnv || fallbackBase;

// // Endpoints
// export const VIDEOS_URL = `${API}/videos/`;
// // (example) export const AUTH_LOGIN = `${API}/auth/login/`;


// apps/web/src/api.ts
const raw = (process.env.REACT_APP_API_URL || '').replace(/\/+$/,''); // may be "", ".../api", or "..."

// Base: env or same-origin
const originBase = `${window.location.protocol}//${window.location.host}`;
const base = raw || originBase;

// Ensure there is exactly one "/api" segment
const hasApi = /(^|\/)api($|\/)/i.test(new URL(base, originBase).pathname);
export const API_BASE = hasApi ? base : `${base}/api`;
const API = API_BASE; // legacy alias used inside this module

export const VIDEOS_URL = `${API.replace(/\/+$/,'')}/videos/`;

// (optional) debug
// console.log('[API BASE]', API, 'VIDEOS_URL', VIDEOS_URL);
